import { render } from "./ConfigSlots.vue?vue&type=template&id=37165991"
import script from "./ConfigSlots.vue?vue&type=script&lang=js"
export * from "./ConfigSlots.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__